/**
 * Same-origin absolute path only (KORA-114; ported from Atlas `safeRedirectPath`). Accepts a string
 * that starts with a single `/`, has no backslash (browsers treat `/\evil.com` like `//evil.com`),
 * and is not the login or callback route (a redirect loop, compared case-insensitively). ASCII
 * control characters are rejected first: browsers strip tabs and newlines from URLs, so `/\t/evil.com`
 * would otherwise become `//evil.com`. Anything else, including full URLs,
 * empty strings and non-strings, returns `fallback`.
 */
export function safeRedirectPath(raw, fallback) {
    if (typeof raw !== 'string')
        return fallback;
    if (/[\u0000-\u001F\u007F]/.test(raw))
        return fallback;
    if (!raw.startsWith('/') || raw.startsWith('//') || raw.includes('\\'))
        return fallback;
    const pathOnly = raw.split(/[?#]/)[0]?.replace(/\/+$/, '').toLowerCase();
    if (pathOnly === '/login' || pathOnly === '/callback')
        return fallback;
    return raw;
}
